export function resolveTableColumnAliases(columns, orderBy, availableColumns) {
    const replacements = (key) => availableColumns
        .filter((column) => column.replaces === key)
        .map((column) => column.key)

    return {
        columns: [...new Set(columns.flatMap((key) => {
            const keys = replacements(key)
            return keys.length ? keys : [key]
        }))],
        orderBy: replacements(orderBy)[0] ?? orderBy,
    }
}
